import { style } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';
import { reducedMotion } from '../../theme/media';

export const content = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

export const info = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '12px',
  background: vars.surface.card.default,
  borderRadius: '8px',
  border: `1px solid ${vars.surface.border.secondary}`,
});

export const submitter = style({
  fontSize: vars.typography.fontSize.sm,
  fontWeight: vars.typography.fontWeight.semibold,
  color: vars.typography.textColor.primary,
});

export const proofTitle = style({
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
});

export const label = style({
  fontSize: vars.typography.fontSize.sm,
  fontWeight: vars.typography.fontWeight.medium,
  color: vars.typography.textColor.secondary,
});

export const required = style({
  color: vars.bright.status.error,
});

export const textarea = style({
  width: '100%',
  minHeight: '100px',
  padding: '12px',
  fontSize: vars.typography.fontSize.sm,
  fontFamily: vars.typography.fontFamily.primary,
  color: vars.typography.textColor.primary,
  background: vars.surface.card.default,
  border: `1px solid ${vars.surface.border.secondary}`,
  borderRadius: '8px',
  resize: 'vertical',
  outline: 'none',
  transition: `border-color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  ':focus-visible': {
    borderColor: vars.surface.border.primary,
  },
  '::placeholder': {
    color: vars.typography.textColor.tertiary,
  },
  '@media': {
    [reducedMotion]: {
      transition: 'none',
    },
  },
});

export const charCount = style({
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
  textAlign: 'right',
});

export const footer = style({
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-end',
});
